import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { NetworkStatusService } from '../../services/network-status.service';

@Component({
  selector: 'app-network-status',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './network-status.component.html',
  styleUrls: ['./network-status.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'hidden',
        style({
          transform: 'translateY(100%)',
          opacity: 0,
        }),
      ),
      state(
        'visible',
        style({
          transform: 'translateY(0)',
          opacity: 1,
        }),
      ),
      transition('hidden <=> visible', [animate('300ms ease-in-out')]),
    ]),
  ],
})
export class NetworkStatusComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isOffline = false;
  dismissed = false;

  constructor(private networkStatusService: NetworkStatusService) {}

  ngOnInit(): void {
    this.networkStatusService.isOnline$
      .pipe(
        debounceTime(500), // Espera 500ms antes de reagir - evita flickering
        distinctUntilChanged(), // Só emite se o valor mudou
        takeUntil(this.destroy$),
      )
      .subscribe(isOnline => {
        this.isOffline = !isOnline;
        // Quando volta online, resetar o dismissed
        if (isOnline) {
          this.dismissed = false;
        }
      });
  }

  get showBanner(): boolean {
    return this.isOffline && !this.dismissed;
  }

  dismiss(): void {
    this.dismissed = true;
  }

  ngOnDestroy(): void {
    if (!this.destroy$.closed) {
      this.destroy$.next();

      this.destroy$.complete();
    }
  }
}
